import React from "react";
import ScoreCard from "../ScoreCard/ScoreCard";
import Urls from "../../api/Urls";
import Skeleton from "react-loading-skeleton";
import Utils from "../../utils/Utils";

export interface QuestionResultCardProps {
  position: number;
  name: string;
  profilePic?: string;
  batchName: string;
  submittedDate: string;
  totalQuize: number;
  correct: number;
  error: number;
  noAnswer: number;
}

const QuestionResultCard: React.FC<QuestionResultCardProps> = ({
  position,
  name,
  profilePic,
  batchName,
  submittedDate,
  totalQuize,
  correct,
  error,
  noAnswer,
}) => {
  return (
    <div className="question-result-card">
      <div className="card-header">
        {profilePic ? (
          <img
            src={Urls.storagePath + profilePic}
            alt={name}
            className="profile-pic"
          />
        ) : (
          <div className="avatar-view">
            <span className="avatar-text">{Utils.getInitials(name)}</span>
          </div>
        )}

        <div className="user-info">
          <h3 className="user-name">{name}</h3>
          <p className="info-row">
            <span className="label">Batch name:</span>
            <span className="value">{batchName}</span>
          </p>
          <p className="info-row">
            <span className="label">Submitted date:</span>
            <span className="value">{submittedDate}</span>
          </p>
        </div>
      </div>

      <div className="score-cards-container">
        <ScoreCard score={position} title="Position" color="#000000" />
        <ScoreCard score={correct} title="Risposte corrette" color="#4CAF50" />
        <ScoreCard score={error} title="Errori da ripassare" color="#F44336" />
        <ScoreCard
          score={
            error > 3 ? (
              <i className="emoji">😢</i>
            ) : (
              <i className="emoji">🏆</i>
            )
          }
          title={error > 3 ? "Non Superato!" : "Superato!"}
          color={error > 3 ? "#F44336" : "#4CAF50"}
        />
      </div>
    </div>
  );
};

export const QuestionResultCardSkeleton: React.FC = () => {
  return (
    <div className="question-result-card">
      <div className="card-header">
        <Skeleton height={80} width={80} circle={true} />
        <div className="user-info">
          <Skeleton width={200} height={24} style={{ marginBottom: 4 }} />
          <Skeleton width={150} height={16} style={{ marginBottom: 2 }} />
          <Skeleton width={180} height={16} />
        </div>
      </div>

      <div className="score-cards-container">
        <div className="skeleton-score-card">
          <Skeleton width={60} height={20} />
          <Skeleton width={50} height={14} />
        </div>
        <div className="skeleton-score-card">
          <Skeleton width={60} height={20} />
          <Skeleton width={50} height={14} />
        </div>
        <div className="skeleton-score-card">
          <Skeleton width={60} height={20} />
          <Skeleton width={50} height={14} />
        </div>
        <div className="skeleton-score-card">
          <Skeleton width={60} height={20} />
          <Skeleton width={50} height={14} />
        </div>
      </div>
    </div>
  );
};

export default QuestionResultCard;
